export default __webpack_public_path__ + "static/media/complementary--railroad--g2.7ae94b03.png";